import script from "./FooterDark.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterDark.vue?vue&type=script&lang=ts&setup=true"

import "./FooterDark.vue?vue&type=style&index=0&id=5164c89c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5164c89c"]])

export default __exports__